import React, { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography, Paper } from '@mui/material';
import { SvgIconProps } from '@mui/material';

import { secondaryButtonBackgroundColor } from '../../constants/colors';
import { regularXl, regularXs, boldMd } from '../../constants/location';
import { useBlockBrowserBack } from '../utils/useBlockBrowserBack';
import CustomSnackbar from './CustomSnackbar';

type CardProps = {
  icon: ReactElement<SvgIconProps>;
  title: string;
  textAligin: string;
  description: string;
  buttonText: string;
  buttonLink: string;
};

const styles = {
  paper: {
    width: '480px',
    padding: '40px',
    textAlign: 'center',
    borderRadius: '4px',
    '@media screen and (max-width: 600px)': {
      width: '343px',
      padding: '32px 16px',
    },
  },

  title: {
    whiteSpace: 'pre-wrap',
    mb: 2,
    ...regularXl,
    '@media screen and (max-width: 600px)': {
      marginBottom: '12px',
    },
  },

  describtion: {
    whiteSpace: 'pre-wrap',
    mb: 4,
    ...regularXs,
    '@media screen and (max-width: 600px)': {
      marginBottom: '20px',
    },
  },
};

const CommonCompleteCard: React.FC<CardProps> = props => {
  const navigate = useNavigate();
  const [open, setOpen] = useBlockBrowserBack();

  return (
    <Paper elevation={0} variant="outlined" square sx={styles.paper}>
      {props.icon}
      <Typography sx={styles.title}>{props.title}</Typography>
      <Box sx={{ textAlign: props.textAligin }}>
        <Typography sx={styles.describtion}>{props.description}</Typography>
      </Box>
      <Button
        variant="outlined"
        fullWidth
        sx={{ ...secondaryButtonBackgroundColor, ...boldMd }}
        onClick={(): void => {
          navigate(props.buttonLink);
        }}
      >
        {props.buttonText}
      </Button>
      <CustomSnackbar
        autoHideDuration={6000}
        open={open}
        onClose={(): void => setOpen(false)}
        text="前のページに戻れません。"
      />
    </Paper>
  );
};

export default CommonCompleteCard;
